import { render, staticRenderFns } from "./EventInfo.vue?vue&type=template&id=14a3cf49&scoped=true"
import script from "./EventInfo.vue?vue&type=script&lang=ts"
export * from "./EventInfo.vue?vue&type=script&lang=ts"
import style0 from "./EventInfo.vue?vue&type=style&index=0&id=14a3cf49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a3cf49",
  null
  
)

export default component.exports